import {Api} from '../../../application/api/api';
import {ConfigProvider} from '../../../application/config/configProvider';

// The HTML carries only the tail of a code (DIS-1395); full codes are revealed by offer.codes.
const CODE_SELECTOR = '[data-offer-code]';
const MAX_IDS_PER_REQUEST = 50;

class OfferCodeLoader
{
    /**
     * Fills every [data-offer-code] element inside the given roots with the full code.
     *
     * @param {Element[]} rootElements
     * @param {function(Set<Number>)} callback receives ids of the offers whose code was filled
     */
    static fill(rootElements, callback = () => {}) {
        let codeElements = rootElements.flatMap((rootElement) => Array.from(rootElement.querySelectorAll(CODE_SELECTOR)));
        let ids = [...new Set(codeElements.map((element) => Number(element.getAttribute('data-offer-code'))))];

        if (ids.length === 0) {
            callback(new Set());
            return;
        }

        let chunks = [];

        for (let i = 0; i < ids.length; i += MAX_IDS_PER_REQUEST) {
            chunks.push(ids.slice(i, i + MAX_IDS_PER_REQUEST));
        }

        let filledIds = new Set();
        let pending = chunks.length;

        chunks.forEach((chunk) => {
            Api.post(ConfigProvider.get('offer_codes_endpoint'), {ids: chunk}, (response) => {
                if (response.isSuccess()) {
                    response.get('codes', []).forEach(({id, code}) => {
                        codeElements
                            .filter((element) => Number(element.getAttribute('data-offer-code')) === id)
                            .forEach((element) => this.setCode(element, code));

                        filledIds.add(id);
                    });
                }

                if (--pending === 0) {
                    callback(filledIds);
                }
            });
        });
    }

    /**
     * @param {Element} element
     * @param {String} code
     */
    static setCode(element, code) {
        if (element.tagName === 'INPUT') {
            element.value = code;
        } else if (element.hasAttribute('data-code')) {
            element.setAttribute('data-code', code);
        } else {
            element.textContent = code;
        }
    }
}

export {OfferCodeLoader};
